import { HTMLElement, Node, NodeType, parse } from 'node-html-parser'

import { sanitizeHtmlId } from '../../helpers/sanitizeId'
import { ContentsDropdown } from './ContentsDropdown'

type MarkupContentProps = {
  readonly content: string
  readonly contentsDropdown: boolean
}

export default function MarkupContent({ content, contentsDropdown }: MarkupContentProps) {
  const { html, contentsTitles } = mapMarkup(content)

  return (
    <section>
      {contentsDropdown && <ContentsDropdown titles={contentsTitles} />}

      <div dangerouslySetInnerHTML={{ __html: html }} />
    </section>
  )
}

const mapMarkup = (content: string) => {
  const html = parse(content)

  const headings = html.querySelectorAll('h1, h2, h3, h4, h5, h6')

  const contentsTitles: Array<{ text: string; id: string }> = []

  headings.forEach(heading => {
    heading.setAttribute('role', 'presentation')

    if (heading.tagName === 'H2') {
      const title = findTextNode(heading)

      heading.setAttribute('id', sanitizeHtmlId(title))

      contentsTitles.push({ text: title, id: heading.id })
    }
  })

  return { html: html.toString(), contentsTitles }
}

const findTextNode = (heading: HTMLElement | Node) => {
  const childNodes = heading.childNodes

  let text = ''

  childNodes.forEach(node => {
    if (node.nodeType === NodeType.TEXT_NODE) {
      text = node.textContent
    } else {
      text = findTextNode(node)
    }
  })

  return text
}
